import { BiCart, BiTrendingDown, BiTrendingUp } from 'react-icons/bi';
import { VscInspect } from 'react-icons/vsc';

import StatCard from '../../../components/statCard/StatCard';
import { useEffect, useState } from 'react';
import { getMarketPulseData } from '../getData';

import { useNotificationContext } from '../../../contexts/NotificationContext';
import { replaceStrVariable } from '../../../utils/replaceStrVariable';

type MarketPulseProps = {
  t: (key: string, replace?: any) => string;
};

const MarketPulse = ({ t }: MarketPulseProps) => {
  const { errorNotification } = useNotificationContext();
  const [inflationData, setInflationData] = useState<{ data: any }>();
  const [deflationData, setDeflationData] = useState<{ data: any }>();

  const [noOfInspections, setNoOfInspections] = useState<{ count: number }>();
  const [avgFoodBasketPrice, setAvgFoodBasketPrice] = useState<{
    averagePrice: number;
    totalPrices: number;
    totalProducts: number;
  }>();

  useEffect(() => {
    const getMarketPulseDataWrapper = async () => {
      try {
        const { avgFoodPrice, inflationData, deflationData, noOfInspectionsData } =
          await getMarketPulseData();
        setAvgFoodBasketPrice(avgFoodPrice);
        setInflationData(inflationData);
        setDeflationData(deflationData);
        setNoOfInspections(noOfInspectionsData);
      } catch (error: any) {
        errorNotification(error.message);
      }
    };

    getMarketPulseDataWrapper();
  }, []);

  return (
    <div className="section mx-10">
      <h1 className="section-title">{t('marketPulseTitle')}</h1>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        <div className="">
          <StatCard
            prefix="L."
            value={avgFoodBasketPrice?.averagePrice || 0}
            title={t('stat1_info')}
            icon={<BiCart size={40} />}
            valueSize={36}
          />
        </div>

        {inflationData && inflationData.data.length > 0 && (
          <>
            <div className="">
              <StatCard
                prefix="+"
                value={Math.abs(inflationData.data[0].priceChangePercentage) + '%'}
                postfix={<BiTrendingUp />}
                title={t('price_stat', {
                  product: inflationData.data[0].productName,
                })}
                icon={<BiTrendingUp size={36} />}
                statColor="red"
                valueSize={36}
              />
            </div>
          </>
        )}

        {inflationData && inflationData.data.length > 1 && (
          <>
            <div className="">
              <StatCard
                prefix="+"
                value={Math.abs(inflationData.data[1].priceChangePercentage) + '%'}
                title={t('price_stat', { product: inflationData.data[1].productName })}
                postfix={<BiTrendingUp />}
                icon={<BiTrendingUp size={36} />}
                valueSize={36}
                statColor="red"
              />
            </div>
          </>
        )}

        <div className="">
          <StatCard
            prefix=""
            value={noOfInspections?.count || 0}
            title={t('stat6_info')}
            icon={<VscInspect size={30} />}
            valueSize={36}
          />
        </div>

        {deflationData && deflationData.data.length > 0 && (
          <>
            <div className="">
              <StatCard
                prefix="-"
                value={Math.abs(deflationData.data[0].priceChangePercentage) + '%'}
                postfix={<BiTrendingDown />}
                title={t('price_stat', {
                  product: deflationData.data[0].productName,
                })}
                icon={<BiTrendingDown size={36} />}
                statColor="green"
                valueSize={36}
              />
            </div>
          </>
        )}

        {deflationData && deflationData.data.length > 1 && (
          <>
            <div className="">
              <StatCard
                prefix="-"
                value={Math.abs(deflationData.data[1].priceChangePercentage) + '%'}
                title={t('price_stat', {
                  product: deflationData.data[1].productName,
                })}
                postfix={<BiTrendingDown />}
                icon={<BiTrendingDown size={36} />}
                valueSize={36}
                statColor="green"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MarketPulse;
